import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("path", {
              fill: "#252729",
              d: "M3.4 8.55c.226-.301.635-.384.956-.21l.094.06 7.4 5.55c.071.053.164.064.243.032l.057-.032 7.4-5.55c.331-.249.802-.181 1.05.15.226.301.191.717-.066.977l-.084.073-7.4 5.55c-.578.433-1.357.464-1.963.093l-.137-.093-7.4-5.55c-.331-.249-.399-.719-.15-1.05z",
              transform: "translate(-752 -1647) translate(116 1631) translate(636 16) matrix(1 0 0 -1 0 23.75)"
            })
          ])
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }